module.exports = __webpack_public_path__ + "img/contTitle_board.bc955c5b.svg";